import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LytButton from 'src/components/library/button/LytButton';
import LytIcon from 'src/components/library/icon/LytIcon';
import { ICON_NAMES } from 'src/components/library/icon/icon-constants';
import {
    applyTypography,
    TYPOGRAPHY_VARIANTS,
} from 'src/components/styled/theme/typography-utils';
import LytModal from 'src/components/ui-core/modal/LytModal';

const TITLE_ID = 'delete-cad-avl-assignment-modal-title';
const DESCRIPTION_ID = 'delete-cad-avl-assignment-modal-description';

const BodyText = styled.p`
    ${applyTypography(TYPOGRAPHY_VARIANTS.SIZE_1_NORMAL)}
    color: ${({ theme }) => theme?.text?.default};
    margin: 0;
`;

const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

/**
 * Confirmation-only CAD/AVL assignment delete modal.
 *
 * The modal returns the selected assignment to its caller; it does not call an
 * endpoint or mutate the table.
 */
const DeleteCadAvlAssignmentModal = ({
    open = false,
    closeModal = undefined,
    assignment = {},
}) => {
    if (!open) {
        return null;
    }

    const handleClose = (result = {}) => {
        closeModal?.({
            confirmed: false,
            ...result,
        });
    };

    const handleConfirm = () => {
        closeModal?.({
            confirmed: true,
            assignment,
        });
    };

    const footerActions = (
        <ButtonGroup>
            <LytButton
                type="secondary"
                onClick={() => handleClose({ reason: 'cancel' })}>
                Cancel
            </LytButton>
            <LytButton type="danger" onClick={handleConfirm}>
                Delete
            </LytButton>
        </ButtonGroup>
    );

    return (
        <LytModal
            open={open}
            title="Are you sure?"
            titleIcon={
                <LytIcon
                    name={ICON_NAMES.BrightnessAlertFill}
                    size={24}
                    color="#C8322A"
                />
            }
            onClose={handleClose}
            actions={footerActions}
            size="small"
            ariaLabelledBy={TITLE_ID}
            ariaDescribedBy={DESCRIPTION_ID}>
            <BodyText id={DESCRIPTION_ID}>
                Are you sure you want to delete this item?
            </BodyText>
        </LytModal>
    );
};

DeleteCadAvlAssignmentModal.propTypes = {
    open: PropTypes.bool,
    closeModal: PropTypes.func,
    assignment: PropTypes.shape({
        mapping_id: PropTypes.string,
        apparatus_id: PropTypes.string,
        unit_id: PropTypes.string,
        apparatusId: PropTypes.string,
        unitId: PropTypes.string,
    }),
};

export default DeleteCadAvlAssignmentModal;
